import { gql } from '@apollo/client'

export const CREATE_BODY_STYLE = gql`
  mutation createBodyStyle($input: CreateBodyStyleInput!) {
    data: createBodyStyle(input: $input) {
      id
    }
  }
`
